@if (data(); as data) {
  <bx-badge
    [bxTooltip]="tooltip"
    [label]="label()"
    [icon]="data.icon"
    [color]="data.color"
    [iconType]="iconOnly() ? 'icon-only' : 'icon-leading'"
    [size]="size()"
  ></bx-badge>
}

<ng-template #tooltip>
  {{ tooltipHeading() }}
</ng-template>
